import { Platform } from "react-native";
import * as SecureStore from "expo-secure-store";

const KEY = "pending_review_dismissed";

function getWebStorage(): Storage | null {
  if (typeof localStorage === "undefined") {
    return null;
  }
  if (
    typeof localStorage.getItem !== "function"
    || typeof localStorage.setItem !== "function"
    || typeof localStorage.removeItem !== "function"
  ) {
    return null;
  }
  return localStorage;
}

/**
 * Platform-aware persistence for whether the vendor has dismissed the
 * pending-review screen by tapping "Go to Dashboard".
 * - Web: localStorage
 * - Native: expo-secure-store
 */
export const pendingReviewStorage = {
  async get(): Promise<boolean> {
    if (Platform.OS === "web") {
      const storage = getWebStorage();
      try {
        return storage ? storage.getItem(KEY) === "1" : false;
      } catch {
        // Safari private mode or storage disabled — treat as not dismissed.
        return false;
      }
    }
    const val = await SecureStore.getItemAsync(KEY);
    return val === "1";
  },

  set(): void {
    if (Platform.OS === "web") {
      const storage = getWebStorage();
      try {
        if (storage) storage.setItem(KEY, "1");
      } catch {
        // Safari private mode or storage quota exceeded — silently no-op.
      }
      return;
    }
    SecureStore.setItemAsync(KEY, "1").catch(() => {});
  },

  remove(): void {
    if (Platform.OS === "web") {
      const storage = getWebStorage();
      try {
        if (storage) storage.removeItem(KEY);
      } catch {
        // Safari private mode or storage quota exceeded — silently no-op.
      }
      return;
    }
    SecureStore.deleteItemAsync(KEY).catch(() => {});
  },
};
